(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-faq"] && !Shopify.designMode) return;
  try {
    
  class MdFaqSection {
    constructor(section) {
      this.section = section;
      this.singleOpen = section.dataset.singleOpen === 'true';
      this.items = Array.from(section.querySelectorAll('.md-faq__item'));
      this.bindEvents();
      this.items.forEach((item) => {
        const panel = item.querySelector('.md-faq__panel');
        if (item.classList.contains('is-open') && panel) {
          panel.hidden = false;
          panel.style.height = 'auto';
        }
      });
    }

    bindEvents() {
      this.items.forEach((item) => {
        const toggle = item.querySelector('.md-faq__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', () => {
          if (item.classList.contains('is-open')) {
            this.closeItem(item);
            return;
          }

          if (this.singleOpen) {
            this.items.forEach((currentItem) => {
              if (currentItem !== item) this.closeItem(currentItem);
            });
          }

          this.openItem(item);
        });
      });
    }

    openItem(item) {
      const toggle = item.querySelector('.md-faq__toggle');
      const panel = item.querySelector('.md-faq__panel');
      if (!toggle || !panel || item.classList.contains('is-open')) return;

      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';

      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });

      panel.addEventListener('transitionend', function handleOpen(event) {
        if (event.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handleOpen);
      });
    }

    closeItem(item) {
      const toggle = item.querySelector('.md-faq__toggle');
      const panel = item.querySelector('.md-faq__panel');
      if (!toggle || !panel || !item.classList.contains('is-open')) return;

      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.height = `${panel.scrollHeight}px`;

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });

      panel.addEventListener('transitionend', function handleClose(event) {
        if (event.propertyName !== 'height') return;
        panel.hidden = true;
        panel.removeEventListener('transitionend', handleClose);
      });
    }
  }

  function initMdFaqSections(root = document) {
    root.querySelectorAll('[data-md-faq]').forEach((section) => {
      if (section.dataset.mdFaqInitialized === 'true') return;
      section.dataset.mdFaqInitialized = 'true';
      new MdFaqSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initMdFaqSections());
  document.addEventListener('shopify:section:load', (event) => initMdFaqSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-image-accordion"] && !Shopify.designMode) return;
  try {
    
  class MdImageAccordionSection {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll('.md-image-accordion__item'));
      this.bindEvents();
      this.items.forEach((item) => {
        const panel = item.querySelector('.md-image-accordion__panel');
        if (item.classList.contains('is-open') && panel) {
          panel.hidden = false;
          panel.style.height = 'auto';
        }
      });
    }

    bindEvents() {
      this.items.forEach((item) => {
        const toggle = item.querySelector('.md-image-accordion__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', () => {
          if (item.classList.contains('is-open')) return;

          this.items.forEach((currentItem) => {
            if (currentItem !== item) this.closeItem(currentItem);
          });

          this.openItem(item);
        });
      });
    }

    openItem(item) {
      const toggle = item.querySelector('.md-image-accordion__toggle');
      const panel = item.querySelector('.md-image-accordion__panel');
      if (!toggle || !panel || item.classList.contains('is-open')) return;

      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';

      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });

      panel.addEventListener('transitionend', function handleOpen(event) {
        if (event.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handleOpen);
      });
    }

    closeItem(item) {
      const toggle = item.querySelector('.md-image-accordion__toggle');
      const panel = item.querySelector('.md-image-accordion__panel');
      if (!toggle || !panel || !item.classList.contains('is-open')) return;

      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.height = `${panel.scrollHeight}px`;

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });

      panel.addEventListener('transitionend', function handleClose(event) {
        if (event.propertyName !== 'height') return;
        panel.hidden = true;
        panel.removeEventListener('transitionend', handleClose);
      });
    }
  }

  function initMdImageAccordionSections(root = document) {
    root.querySelectorAll('[data-md-image-accordion]').forEach((section) => {
      if (section.dataset.mdImageAccordionInitialized === 'true') return;
      section.dataset.mdImageAccordionInitialized = 'true';
      new MdImageAccordionSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initMdImageAccordionSections());
  document.addEventListener('shopify:section:load', (event) => initMdImageAccordionSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-image-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const visibleVideos = new Set();
    const updatePlayback = (video) => {
      if (visibleVideos.has(video) && !document.hidden) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
        if (isIntersecting && intersectionRatio >= 0.25) {
          visibleVideos.add(target);
        } else {
          visibleVideos.delete(target);
        }
        updatePlayback(target);
      });
    }, { threshold: [0, 0.25] });
    const initialize = (root) => {
      root.querySelectorAll('.md-image-cta__video').forEach((video) => {
        if (video.dataset.mdPlaybackBound) return;
        video.dataset.mdPlaybackBound = 'true';
        video.muted = true;
        observer.observe(video);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.md-image-cta__video').forEach((video) => {
        visibleVideos.delete(video);
        observer.unobserve(video);
        video.pause();
      });
    });
    document.addEventListener('visibilitychange', () => visibleVideos.forEach(updatePlayback));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
